<form [formGroup]="rollNumberConfigForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header">
        {{type}} Roll Number Configuration
        <div class="absolute right-2">
            <button (click)="onCancel()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content">
        <!-- Department and Academic Year -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Department</label>
                <p-select 
                    formControlName="department_id"
                    [options]="allDepartments"
                    placeholder="Select Department"
                    optionLabel="label"
                    optionValue="value">
                </p-select>
                <small *ngIf="rollNumberConfigForm.get('department_id')?.invalid && isSubmitted" class="p-error">
                    Department is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Academic Year</label>
                <p-select 
                    formControlName="academic_year_id"
                    [options]="allAcademicYears"
                    placeholder="Select Academic Year"
                    optionLabel="label"
                    optionValue="value">
                </p-select>
                <small *ngIf="rollNumberConfigForm.get('academic_year_id')?.invalid && isSubmitted" class="p-error">
                    Academic Year is required
                </small>
            </div>
        </div>

        <!-- Prefix and Counter -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Prefix</label>
                <input 
                    pInputText
                    formControlName="prefix"
                    placeholder="Enter prefix (e.g., CSE, IT)"
                    maxlength="20" />
                <small *ngIf="rollNumberConfigForm.get('prefix')?.invalid && isSubmitted" class="p-error">
                    Prefix is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Counter</label>
                <p-inputNumber
                    formControlName="counter"
                    placeholder="Starting counter value"
                    [min]="0"
                    [style]="{'width': '100%'}">
                </p-inputNumber>
                <small *ngIf="rollNumberConfigForm.get('counter')?.invalid && isSubmitted" class="p-error">
                    Counter is required
                </small>
            </div>
        </div>

        <!-- Length -->
        <div class="field">
            <label class="requiredValue">Number Length</label>
            <p-inputNumber
                formControlName="length"
                placeholder="Number of digits for roll number"
                [min]="1"
                [max]="10"
                [style]="{'width': '100%'}">
            </p-inputNumber>
            <small *ngIf="rollNumberConfigForm.get('length')?.invalid && isSubmitted" class="p-error">
                Number Length is required
            </small>
            <small class="text-gray-500 block mt-1">
                This determines how many digits the roll number will have (e.g., 3 digits = 001, 002, 003...)
            </small>
        </div>

        <!-- Action buttons -->
        <div class="flex justify-end gap-2 mt-8">
            <p-button label="Cancel" severity="danger" variant="outlined" (click)="onCancel()"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
                (click)="onSubmit()"></p-button>
        </div>
    </div>
</form>
